"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addLineItemsFromLogisticOrderToCart = exports.ADD_LINE_ITEMS_FROM_LOGISTIC_ORDER_PATH = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
exports.ADD_LINE_ITEMS_FROM_LOGISTIC_ORDER_PATH = `/v1/bff/appro/carts/add-line-items-from-logistic-order`;
const addLineItemsFromLogisticOrderToCart = (client) => async ({ logisticOrderId, membershipNumber, cooperativeId }) => {
    try {
        const response = await client.post(exports.ADD_LINE_ITEMS_FROM_LOGISTIC_ORDER_PATH, {
            logisticOrderId,
            membershipNumber,
            cooperativeId
        });
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.addLineItemsFromLogisticOrderToCart = addLineItemsFromLogisticOrderToCart;
